/* @flow */
import React from 'react';
import Text from 'components/Text.jsx';
import Time from 'components/Time.jsx';
import cx from 'classnames';

import './styles/SimpleDateIcon.scss';

type Props = {
  date?: Date,
  className?: ?string,
  dayTextProps?: ?Object,
  monthTextProps?: ?Object,
}

class SimpleDateIcon extends React.Component {
  props: Props;

  render() {
    return (
      <div className={cx('SimpleDateIcon', this.props.className)}>
        <div className="SimpleDateIcon-month">
          <Text {...this.props.monthTextProps}>
            <Time date={this.props.date} month="short" />
          </Text>
        </div>
        <div className="SimpleDateIcon-day">
          <Text {...this.props.dayTextProps}>
            <Time date={this.props.date} day="numeric" />
          </Text>
        </div>
      </div>
    );
  }
}

export default SimpleDateIcon;



// WEBPACK FOOTER //
// ./src/components/SimpleDateIcon.jsx